export class ProcessingQueueRequest {
	functionId: string;
	functionArgument: string;
	docId: string;
	caseId?: string;
}
